<template>
  <form @submit.prevent="submit">
    <div class="space-y-2">
      <InputTextArea
        v-model="form.body"
        placeholder="Type your comment here..."
        :error="form.errors.body"
        ref="target"
      />
      <InputError :message="form.errors.body" />
      <div class="flex justify-end">
        <div class="space-x-2">
          <ButtonBase
            size="sm"
            color="white"
            @click="emit('close')"
            :disabled="form.processing"
            >Cancel</ButtonBase
          >
          <ButtonBase size="sm" type="submit" :processing="form.processing">{{
            isEditing ? 'Save' : 'Post'
          }}</ButtonBase>
        </div>
      </div>
    </div>
  </form>
</template>

<script setup>
import ButtonBase from '@/Common/Elements/Buttons/ButtonBase.vue'
import InputError from '@/Common/Forms/Inputs/InputError.vue'
import InputTextArea from '@/Common/Forms/Inputs/InputTextArea.vue'
import { useForm } from '@inertiajs/inertia-vue3'
import { useFocus } from '@vueuse/core'
import { computed, ref, watch } from 'vue'

const props = defineProps({
  trip: Object,
  comment: Object,
})

const emit = defineEmits(['close', 'success'])

const form = useForm({
  body: '',
})

const isEditing = computed(() => !!props.comment)

const formRoute = computed(() =>
  isEditing.value
    ? route('trips.comments.update', props.comment)
    : route('trips.comments.store', props.trip)
)

const formMethod = computed(() => (isEditing.value ? 'put' : 'post'))

function submit() {
  form.submit(formMethod.value, formRoute.value, {
    preserveScroll: true,
    preserveState: true,
    onSuccess: () => {
      emit('success')
      emit('close')
    },
  })
}

watch(
  () => props.comment,
  () => {
    if (props.comment) form.body = props.comment.body
  },
  { immediate: true }
)

const target = ref()
useFocus(target, { initialValue: true })
</script>
